import { createFileRoute } from '@tanstack/react-router'
import authClient from '#/auth/authClient'
import { LandingPage } from '#/components/LandingPage'

export const Route = createFileRoute('/')({
  component: IndexRedirect,
})

function IndexRedirect() {
  const { data: session, isPending } = authClient.useSession()
  const accountUrl = import.meta.env.VITE_QUICKBACK_ACCOUNT_URL || '/account'

  if (isPending) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    )
  }

  if (!session) {
    return <LandingPage />
  }

  // Redirect to account UI profile — org selection happens there
  window.location.href = `${accountUrl}/profile`
  return null
}
